
import viewRelateFlow from '@/components/browse/view-relate-flow';
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {getFieldConfig} from '../sources/source.js';
import dynamicSingleField from '../sources/source-common-module/dynamic-single-field'
import dynamicMultField from '../sources/source-common-module/dynamic-mult-field';
export default {
name: "price-approval-check",
directives: {
TransferDom
},
components: {
viewRelateFlow,
Popup,
dynamicSingleField,
dynamicMultField,
PopupHeader
},
props: ['dataId'],
data() {
return {
priceApproval: {},
index: 1,
gridList: [
{icon:require('@/assets/icon/supplier/supplier_base_data.png'),label:'基本信息'},
{icon:require('@/assets/icon/supplier/bidding_detail.png'),label:'物料明细'},
{icon:require('@/assets/icon/supplier/com_order_flow.png'),label:'流程信息'},
],
priceDetail:{},
levelPriceShow:false,
reducePriceShow:false
}
},
methods: {
valid(){
return true;
},
formData(){
return this.priceApproval;
},
itemTab(index) {
this.index = index;
if(index === 3){
this.$emit('changeFlowInfo',true);
}else{
this.$emit('changeFlowInfo',false);
}
},
changeShow(data) {
if (data.showContent) {
this.$set(data, 'showContent', false);
return;
}
this.$set(data, 'showContent', true);
},
getPriceApproval() {
this.$loadingShow();
this.$get('api/paPrcapp/' + this.dataId).then((data) => {
if (data) {
this.priceApproval = data;
if(this.priceApproval.rfqPaStatus === 'rfq'){
this.getPriceTem();
}
}
this.$loadingHide();
}).catch((error) => {
this.$loadingHide();
});
},
viewPriceParity(code){
let object = {
number: 0,
rules: [{field: "code", option: "EQ", values: [code], collectIndex: -1}],
size: 1
};
this.$loadingShow();
if(this.priceApproval.sourceComparePriceId && this.priceApproval){
this.$router.push(`/parity-detail/${this.priceApproval.sourceComparePriceId}`);
} else {
this.$post('api/sourceComparePrice/page',object).then((res) => {
if(res && res.content && res.content[0]){
this.$router.push(`/parity-detail/${res.content[0].id}`);
}
this.$loadingHide();
}).catch(() => {
this.$loadingHide();
})
}
},
getPriceTem(){
let priceTemIds = [];
this.priceApproval.paDts.forEach((item) => {
if(item.sourcePriceTemplateId){
priceTemIds.push(item.sourcePriceTemplateId);
}
item.offerFieldList = [];
item.inquiryFieldList = [];
});
let set = new Set(priceTemIds);
let priceTemsObs = [];
set.forEach((item) => {
priceTemsObs.push(new Promise((resolve,reject) => {
this.$get(`api/sourcePriceTemplate/${item}`).then((res) => {
resolve(res);
}).catch((err) => {
reject(err);
})
}))
});
Promise.all(priceTemsObs).then((res) => {
this.priceApproval.paDts.forEach((item) => {
let temList = res.filter((template) => {
return template.id === item.sourcePriceTemplateId;
});
if(temList && temList[0]){
const fieldConfig = getFieldConfig(temList[0]);
item.offerFieldList = fieldConfig.offerFieldList;
item.inquiryFieldList = fieldConfig.inquiryFieldList;
item.templateObj = temList[0];
}
});
});
},
viewField(field,dynamicData){
this.$refs.multMatDynamic.initData(field,dynamicData);
},
changeSelected(data,str){
this.$set(data,'showInfoType',str);
},
viewPriceDetail(){
this.$vux.toast.text(`请前往pc端查看价格明细详情`);
},
viewLevelPrice(dto){
this.priceDetail = dto;
this.levelPriceShow = true;
},
viewReducePrice(dto){
this.priceDetail = dto;
this.reducePriceShow = true;
},
cancelLevelPrice(){
this.levelPriceShow = false;
},
cancelReducePrice(){
this.reducePriceShow = false;
}
},
mounted(){
this.getPriceApproval();
}
}



// WEBPACK FOOTER //
// ./src/page/price-approval/price-approval-check.vue